// extracted by mini-css-extract-plugin
export default {"breadcrum":"BreadCrum_breadcrum__npRnI","black":"BreadCrum_black__1vgtv"};